<div class="modal-content modal-xl">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-eye" aria-hidden="true"></i> {{title}}</h4>
    <button type="button" class="close" (click)="accept()" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
<!--    <label class="fz-2em font-weight-bold text-center">{{title}}</label>-->
<!--    <br>-->
    <div class="row">
      <div class="col">
        <div class="mt-2" style="height: 600px">
          <ng2-pdfjs-viewer [pdfSrc]="urlStream"
                            [fullScreen]="true"
                            [locale]="'es-ES'"
                            [showSpinner]="true"
                            (onDocumentLoad)="onProgress()"
                            (onAfterPrint)="urlStream"
                            [errorOverride]="true" errorMessage="No se encontró el archivo pdf">
          </ng2-pdfjs-viewer>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="accept()">
      <i class="fas fa-check"></i> {{'BUTTON.ACCEPT'  | translate}}
    </button>
  </div>
</div>
